import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { captureExceptionSafely } from '@/helpers/capture-exception-safely';

import {
  createTeamContact,
  type TeamContactPayload,
} from '@/api/v4/team-contacts.api';
import { notify } from '@/ui/snackbar/notify';

type CreateTeamContactMutationParams = {
  teamId: string;
  payload: TeamContactPayload;
};

export const useCreateTeamContact = () => {
  const { t } = useTranslation('default');

  return useMutation({
    mutationFn: async ({
      teamId,
      payload,
    }: CreateTeamContactMutationParams) => {
      return createTeamContact(teamId, payload);
    },
    onError: (error: Error) => {
      notify({
        message: t`unknownError`,
      });
      captureExceptionSafely(error);
    },
  });
};
